// extracted by css-extract-rspack-plugin
export default {"list":"nc2gJQ4ldEAGYXsT","label":"DsJuKJMy7kZwCFiy","listItem":"fMyjFzOW__EXpwVk","text":"YyeoCsjLH2cRBy6u"};